import React, { Component } from 'react';
import WrongBtn from '../examBtns/wrongBtn';
import ExamImgModal from '../examModal/examImgModal';
import Pen from '../pen/pen';
import Sheet from '../sheet/sheet';
import ExamImg from './examImg';

class Exam extends Component {
    state = {
        addClass: false,
        imgViewClass: false,
        examInfo: [
            {id: 1, examNum: '①', text: '증가한다.'},
            {id: 2, examNum: '②', text: '감소한다.'},
            {id: 3, examNum: '③', text: '똑같다.'},
            {id: 4, examNum: '④', text: '증가하다가 감소한다.'},
            {id: 5, examNum: '⑤', text: '알 수 없다.'}
        ]
    };

    /*handleChange = (event) => {
        const memoValue = this.state.memoValue;
        const text = this.textareaRef.current.value;
        this.setState({memoValue: text});
        console.log(`memoValue: ${this.state.memoValue}`);
    };*/

    handleImgOpen = () => {
        const imgViewClass = this.state.imgViewClass;
        this.setState({imgViewClass: true});
    };

    handleImgClose = () => {
        const imgViewClass = this.state.imgViewClass;
        this.setState({imgViewClass: false});
    };

    render() {
        return (
            <>
                <div className={this.props.examHalfClass === true ? "exam half-exam" : "exam"}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="title m-0">[5] 예시문항</h1>
                        <div className="title-btn-wrap btn-wrap d-flex justify-content-end">
                            <button className={this.props.examCheckClass === true ? "btn check-btn check-active" : "btn check-btn"} onClick={this.props.onExamChecked}>
                                <span className="icon-wrap">
                                    <svg className="icon check-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M85.286,162.286a.854.854,0,0,1-.606-.251l-3.429-3.429a.857.857,0,0,1,1.212-1.212l2.823,2.823,6.251-6.252a.857.857,0,0,1,1.212,1.212l-6.857,6.858A.857.857,0,0,1,85.286,162.286Z" transform="translate(-75 -146)" fill="#999"/>
                                    </svg>
                                </span>
                                <b>체크문제</b>
                            </button>
                            <button className={this.props.examMemoClass === true ? "btn memo-btn memo-active" : "btn memo-btn"} onClick={this.props.onExamMemo}>
                                <span className="icon-wrap">
                                    <svg className="icon memo-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <g transform="translate(-883.168 -111.484)">
                                            <path className="fill" d="M896.946,124.373h-1.778a.889.889,0,0,1-.889-.889v-1.777a.889.889,0,0,1,.261-.629l5.333-5.333a.889.889,0,0,1,1.257,0l1.778,1.778a.889.889,0,0,1,0,1.257l-5.333,5.333A.888.888,0,0,1,896.946,124.373Zm-.889-1.777h.521l4.445-4.445-.521-.521-4.445,4.445Z" fill="#999"/>
                                            <path className="fill" d="M900.5,131.484H888.057a.889.889,0,0,1-.889-.888V118.151a.889.889,0,0,1,.889-.889h6.222a.889.889,0,1,1,0,1.778h-5.333v10.667h10.667v-5.334a.889.889,0,0,1,1.778,0V130.6A.889.889,0,0,1,900.5,131.484Z" fill="#999"/>
                                        </g>
                                    </svg>
                                </span>
                                <b>메모</b>
                            </button>
                        </div>
                    </div>
                    <p className="explain">다음 내용을 읽고 아래 각 문항에 대해서 가장 적절한 답을 한 가지 고르시오.</p>
                    <div className="exam-body d-flex justify-content-between">
                        <div className="sub-title">
                            <b className="exam-num">
                                5
                                <span className={this.props.examCheckClass === true ? "icon-wrap" : "icon-wrap check-icon-hide"}>
                                    <svg className="icon check-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M85.286,162.286a.854.854,0,0,1-.606-.251l-3.429-3.429a.857.857,0,0,1,1.212-1.212l2.823,2.823,6.251-6.252a.857.857,0,0,1,1.212,1.212l-6.857,6.858A.857.857,0,0,1,85.286,162.286Z" transform="translate(-75 -146)" fill="#999"/>
                                    </svg>
                                </span>
                            </b>
                            자동차 정면충돌 후 25세 남자가 다발성 갈비뼈 골정로 호흡곤란을 호소한다. 호흡시 가슴에서 모순운동이 관찰되는 이 환자에 대한 처치는?
                        </div>
                        <Pen />
                    </div>
                    <div className="img-box img-view-container" onClick={this.handleImgOpen}>
                        <ExamImg />
                    </div>
                    <form name="exam-select">
                        <ul className="select-container m-0 p-0">

                            {this.state.examInfo.map(item => (
                                <li className="main-exam">
                                    <div className="sheet-div">
                                        <WrongBtn info={item.id} />
                                        <Sheet info={item} onSheetSelect={this.props.onSheetSelect} />
                                    </div>

                                    <div className="sheet-img"><img src="https://images.unsplash.com/photo-1508739773434-c26b3d09e071?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="" /></div>
                                </li>
                                
                            ))}

                        </ul>
                    </form>
                </div>
                <ExamImgModal imgViewClass={this.state.imgViewClass} onImgClose={this.handleImgClose} />
            </>
        );
    }
}

export default Exam;